/**
 * Wraps the `value` in an array unless it's already an array.
 * Returns an empty array if the `value` is `null` or `undefined`
 */
export function arrify <T> (value: T | T[] | undefined | null): T[] {
  return value == null ? []
    : Array.isArray(value) ? value
    : [value]
}
